import './App.css'
import { RouterProvider } from '@tanstack/react-router'
import { router } from './router'
import { SentryErrorBoundary } from '@/lib/monitoring'

function App() {
  return (
    <SentryErrorBoundary>
      <RouterProvider router={router} />
    </SentryErrorBoundary>
  )
}

export default App
